import CONNECT_GA from '@/graphql/Website/Integrations/GoogleAnalytics/ConnectGoogleAnalyticsIntegration.gql';
import UPDATE_GA from '@/graphql/Website/Integrations/GoogleAnalytics/UpdateConnectionGoogleAnalyticsIntegration.gql';
import { authClient } from '../main'

export default class GaResource {
    async connect (websiteId, googleId, isAlwaysPushPageViews, sendDisapproveTransactions) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: CONNECT_GA,
            variables: {
                websiteId: websiteId,
                googleId: googleId,
                isAlwaysPushPageViews: isAlwaysPushPageViews,
                sendDisapproveTransactions: sendDisapproveTransactions,
            }
        })
    }

    async updateConnection (websiteId, googleId, isAlwaysPushPageViews, sendDisapproveTransactions) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: UPDATE_GA,
            variables: {
                websiteId: websiteId,
                googleId: googleId,
                isAlwaysPushPageViews: isAlwaysPushPageViews,
                sendDisapproveTransactions: sendDisapproveTransactions,
            }
        })
    }
}
